import { Alert as ChakraAlert } from "@chakra-ui/react"

export default function Alert({ title, children, indicator, status = 'info', ...props }){
    return(
    <ChakraAlert.Root status={status} {...props}>
        <ChakraAlert.Indicator children={indicator} />
        <ChakraAlert.Content>
          { title && <ChakraAlert.Title children={title} fontSize={'15px'} mb={3} />}
          <ChakraAlert.Description children={children} fontSize={'14px'} />
        </ChakraAlert.Content>
      </ChakraAlert.Root>
    )
}